<template>
  <div>
    <button  class="btn btn-info no-print" @click="makePrintable">hide</button>
    <section class="sheet padding-10mm">

    </section>
  </div>
</template>

<script>

import {PrintTls} from '../app/tools/PrintTls';

export default {
  name: "PrintArea",
  props: [],
  data() {
    return {
     

    };
  },
  methods: {
    makePrintable() {
    
PrintTls.makePrintable();
    },
  },
  mounted() {},
  watch: {
    // whenever active changes, this function will run
    // active: function () {
    //   document.body.style.overflow = this.printable ? "A4 landscape" : "";
    // },
  },
};
</script>
<style scoped>

@page {
  size: A4 landscape;
}
</style>



